import { useProperty, useTranslation } from '@eti/providers';
import { useRef } from 'react';
import { useLinksAccessibility } from '../../custom-hooks/useLinkAccessibility';
import ProductLayout from '../../common/main-layout/ProductLayout';
import { useIllustration } from '../../common/utils/useIllustration';
import { CANCEL_24_HOURS } from '../../products';
import { getProduct } from '../../single-choice/utils/singleChoiceTransformer';
import { getPriceProps, getReadMoreLabel, getSingleChoiceProps, getUpsellProps } from '../../common/utils/productCardProps';
import getTranslatedTexts from '../../common/text-resolvers/utils/getTranslatedTexts';
import { useProductSnowplowTracking } from '../../custom-hooks/useProductSnowplowTracking';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  name: PRODUCT_NAME,
  id: PRODUCT_ID
} = CANCEL_24_HOURS;
const texts = {
  persuasionContent: 'cancelTwentyFourHoursPersuasionContent',
  readMoreContent: 'cancelTwentyFourHoursAdditionalSalesText',
  description: 'cancelTwentyFourHoursAbstract',
  title: 'cancelTwentyFourHoursTitle',
  upSell: 'cancelTwentyFourHoursUpSell'
};
const MainCancelTwentyFourHours = ({
  className,
  form,
  isSelected,
  order,
  sellSpecification,
  productPosition
}) => {
  const {
    t,
    nonDebugT
  } = useTranslation();
  const translation = getTranslatedTexts(texts, t);
  const {
    p
  } = useProperty();
  const illustrationUrl = useIllustration(PRODUCT_NAME);
  const product = getProduct(PRODUCT_ID, order, 'traveler');
  const rootElement = useRef(null);
  const {
    description,
    readMoreContent,
    title
  } = translation;
  useProductSnowplowTracking(PRODUCT_NAME, {
    productPosition,
    rootElement
  });
  useLinksAccessibility({
    targetElement: rootElement,
    productTitle: title
  });
  if (!product) {
    return null;
  }
  const {
    priceRaw
  } = product;
  const {
    upSellObject,
    isUpsellHighlight = false,
    shouldDisplayUpsell = false
  } = getUpsellProps(translation.upSell);
  const {
    priceLabel,
    price,
    priceSuffix
  } = getPriceProps(t, isSelected, product);
  const extraProps = getSingleChoiceProps(t, p, nonDebugT);
  const readMoreButtonLabel = getReadMoreLabel(t);
  const productData = {
    className,
    description,
    extraProps,
    form,
    illustrationUrl,
    isHighlighted: isUpsellHighlight,
    isSelected,
    price,
    priceLabel,
    priceRaw,
    priceSuffix,
    productId: PRODUCT_ID,
    productName: PRODUCT_NAME,
    productPosition,
    readMoreButtonLabel,
    readMoreContent,
    shouldDisplayUpsell,
    title,
    travelers: order.travelers,
    upSell: upSellObject,
    sellSpecification
  };
  return /*#__PURE__*/_jsx(ProductLayout, {
    productData: productData,
    ref: rootElement
  });
};
export default MainCancelTwentyFourHours;
//# sourceMappingURL=MainCancelTwentyFourHours.js.map